'use client';

import clsx from 'clsx';
import type { ReactNode, RefObject } from 'react';

export const ProductCardGridItem = ({
  children,
  highlight,
  className,
  id,
  title,
  onFocus,
  onMouseOver,
  ref,
  height,
  'aria-setsize': ariaSetSize,
  'aria-posinset': ariaPosInSet,
}: {
  children: ReactNode;
  highlight?: boolean;
  className?: string;
  id: string;
  /* 
    Make sure to provide a `title` if you set the brand and/or name to truncate somehow.
  */
  title?: string;
  onFocus?: () => void;
  onMouseOver?: () => void;
  ref?: RefObject<HTMLLIElement | null>;
  height?: string;
  'aria-setsize'?: number;
  'aria-posinset'?: number;
}) => (
  <li
    id={id}
    title={title}
    className={clsx(
      'product-card [&:has(.product-card-name:hover)]:bg-color-grey-light relative mb-2 grid overflow-hidden rounded shadow-xs transition-all [&:has(.product-card-name:hover)]:shadow-sm',
      highlight && 'highlight',
      className,
    )}
    onFocus={onFocus}
    onMouseOver={onMouseOver}
    ref={ref}
    style={{ height }}
    aria-setsize={ariaSetSize}
    aria-posinset={ariaPosInSet}
  >
    {children}
  </li>
);
